import React, { Component } from 'react';
import imageButtonCountLeft from './img/text02_left.png';
import imageButtonCountRight from './img/text02_right.png';
import imageButtonRepeat from './img/btn06.png';
import imageButtonBack from './img/btn07.png';
import imageButtonNext from './img/btn08.png';
import imageButtonFinish from './img/btn09.png';
import imageButtonAnswer from './img/answer.png';
import ViewResult from './result';
import ViewAnswer from './answer';
import './view.css';

class ViewGame extends Component { //ReactのComponentクラスを継承
    render() {
        return ( //画面上に表示すべきものを返す
            <div className="container centering">
                <div className="buttons" id="btn">
                    <div className="smallleft" onClick={this.props.onClickAnswer}>
                        <img src={imageButtonAnswer} id="answer"></img>
                    </div>
                </div>
                <div className="topimage" id="top">
                    <div>
                        <img src={imageButtonCountLeft} id="left"></img>
                    </div>
                    <div id="number">{this.props.number}</div>
                    <div>
                        <img src={imageButtonCountRight} id="right"></img>
                    </div>
                </div>
                <div className="buttons" id="btn">
                    <div className="large" onClick={this.props.onClickRepeat}>
                        <img src={imageButtonRepeat} id="repeat"></img>
                    </div>
                    <div className="middle">
                        <div onClick={this.props.onClickPrevious}>
                            <img src={imageButtonBack} id="previous"></img>
                        </div>
                        <div onClick={this.props.onClickNext}>
                            <img src={imageButtonNext} id="next"></img>
                        </div>
                    </div>
                    <div className="small" onClick={this.props.onClickFinish}>
                        <img src={imageButtonFinish} id="finish"></img>
                    </div>
                </div>
                {this.props.page === 'prompt' ?
                    <ViewResult
                        onClickYes={this.props.onClickYes}
                        onClickNo={this.props.onClickNo}
                        onClickModal={this.props.onClickModal}
                    /> : null}
                {this.props.page === 'answer' ?
                    <ViewAnswer
                        onClickClose={this.props.onClickClose}
                        onClickCard={this.props.onClickCard}
                        onClickModal={this.props.onClickModal}
                        current={this.props.current}
                    /> : null}
            </div>
        );
    }
}

export default ViewGame;
